import React, {PropsWithChildren} from 'react';
import {SnackbarProvider as NotistackProvider, useSnackbar as useNotistackSnakbar} from 'notistack';

// Wrapper over material-ui and its recommendation of notistack for maxSnack
// It supplies a Provider and the useSnackbar hook
// https://material-ui.com/components/snackbars
export const useSnackbar = () => useNotistackSnakbar();

export function SnackbarProvider ({ children }: PropsWithChildren<any>) {
    return (
        <NotistackProvider maxSnack={3} preventDuplicate>
            {children}
        </NotistackProvider>
    );
}
